import React from 'react'

import Caption from '../Caption'
import { DashboardItemProps } from '../types'

export default function UpdatedAt({
    componentStyle,
    data,
}: Readonly<DashboardItemProps>) {
    const updatedAt = new Date(data.dashboard.lastUpdated).toLocaleDateString(
        'en-US',
        {
            month: 'long',
            year: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
        },
    )

    const newData = {
        ...data,
        label: `Updated at ${updatedAt}`,
    }

    return <Caption componentStyle={componentStyle} data={newData} />
}
